import { useQuery } from "@apollo/client";
import { withJsonFormsControlProps } from "@jsonforms/react";
import { Dropdown } from "pepsico-ds";
import { useEffect, useMemo, useState } from "react";
import { listRewardTypes } from "../../../graphql/queries/listRewardTypes";

const RewardTypeSelectComponent = ({
  handleChange,
  label,
  data,
  path,
  uischema,
  required,
}) => {
  const { data: rewardTypesData, loading } = useQuery(listRewardTypes);
  const rewardTypesList = useMemo(
    () => rewardTypesData?.listRewardType?.items || [],
    [rewardTypesData]
  );

  const formattedOptions = useMemo(() => {
    if (!loading) {
      return (
        rewardTypesList.map((child) => ({
          id: child?.id,
          displayText: child.name || "",
        })) || []
      );
    }
    return [];
  }, [loading, rewardTypesList]);

  const [selectedValues, setSelectedValues] = useState([]);

  useEffect(() => {
    if (data?.length && rewardTypesList.length) {
      const values = data
        .filter((selectedValueId) =>
          formattedOptions.find((option) => selectedValueId === option?.id)
        )
        .map((selectedValueId) =>
          formattedOptions.find((option) => selectedValueId === option?.id)
        );

      if (values?.length > 0) {
        setSelectedValues(values);
      }
    } else {
      setSelectedValues([]);
    }
  }, [data, formattedOptions, rewardTypesList.length]);

  const formatData = (listOptions) =>
    listOptions ? listOptions?.map((item) => item.id) : [];

  const handleChangeValues = (newValues) => {
    handleChange(path, formatData(newValues));
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="multiple-id-selector multiple-select-wrap peacock-dropdown-show-label">
      <Dropdown
        label={label}
        placeholder={uischema?.placeholder ?? "Reward Type"}
        childList={formattedOptions}
        selection={uischema?.selection ?? "multiple"}
        isRequired={required}
        disabled={uischema?.disabled || uischema?.options?.readonly}
        selectedValue={selectedValues}
        setSelectedValue={handleChangeValues}
      />
    </div>
  );
};

export const RewardTypeSelectControl = withJsonFormsControlProps(
  RewardTypeSelectComponent
);
